const chainIdToName: { [key: number]: string } = {
  100: 'Gnosis',
  10200: 'Chiado',
  1740: 'Apechain',
  33111: 'Curtis',
  42161: 'Arbitrum',
  421613: 'Arbitrum Goerli',
  8453: 'Base',
  84531: 'Base Goerli',
  88888: 'Chiliz',
  88882: 'Chiliz Spicy Testnet',
  137: 'Polygon',
  80002: 'Amoy',
  42220: 'Celo',
  44787: 'Celo Alfajores',
  5000: 'Mantle',
  5001: 'Mantle Testnet',
  5003: 'Mantle Sepolia Testnet',
  59144: 'Linea',
  59140: 'Linea Goerli',
  1337: 'Unichain',
  1301: 'Unichain Sepolia Testnet',
}

export const getChainName = (chainId: number | null): string => {
  if (chainId === null) {
    return 'N/A'
  }
  return chainIdToName[chainId] || `Unknown (${chainId})`
}
